import React from "react";

import { FemaleIcon } from "@/Components/Icons/FemaleIcon";
import { MaleIcon } from "@/Components/Icons/MaleIcon";
import { TransGenderIcon } from "@/Components/Icons/TransGenderIcon";

/**
 * Generates a gender icon based on the input gender.
 *
 * @param {string} gender - The gender to generate the icon for.
 * @return {JSX.Element} The gender icon component.
 */
const GenderIcon = ({ gender }) => {
  const data = {
    Male: {
      icon: <MaleIcon />,
      cls: "bg-primary",
    },
    Female: {
      icon: <FemaleIcon />,
      cls: "bg-pink",
    },
    Other: {
      icon: <TransGenderIcon />,
      cls: "from-primary to-pink bg-gradient-to-tr from-50% to-50%",
    },
  };
  if (gender === null || gender === undefined) return null;
  return (
    <div className="GenderIcon_Wrapper">
      <div
        className={`grid h-[23px] w-[23px] place-items-center rounded-lg text-white ${data[gender]?.cls}`}
      >
        {data[gender]?.icon}
      </div>
    </div>
  );
};

export default GenderIcon;
